jQuery(document).ready(function ($) {
    // View more product slice action
    $('div.viewMoreButtonSliceContainer').click(function (){
        $(this).hide();
        $(this).next('.Products_Container').show();
    });

    //Vanila parallax changes.
    var winScrollTop=0;

    $.fn.is_on_screen = function(){
        var win = $(window);
        var viewport = {
            top : win.scrollTop(),
            left : win.scrollLeft()
        };
        //viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        //bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    function parallax() {
        var scrolled = $(window).scrollTop();
        $('.storyBoardVideo').each(function(){

            if ($(this).is_on_screen()) {
                var firstTop = $(this).offset().top;
                var $span = $(this).find(".storyVideo");
                var storyVideoTop = $span.offset().top;
                var moveTop = (firstTop-winScrollTop)*0.3 //speed;
                $span.css("transform","translateY("+-moveTop+"px)");

            } else {
                $(this).find(".storyVideo").css("transform","translateY("+"0px)");
            }

        });
    }

    $(window).scroll(function(e){
        winScrollTop = $(this).scrollTop();
        if($(window).width() > 767) {
            parallax();
        }
    });
    //End of vanila parallax changes.

    //FAQ Accordion Changes
    let timing = 300;
    let questionDiv = $('#FAQ .faq-q');
    let answerDiv = $('.faq-a');

    $(questionDiv).click(function() {
        if ($(this).children(answerDiv).hasClass('openFAQ')) {
            $(this).removeClass('active');
            $(this).children(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(timing);
        } else if ($(answerDiv).hasClass('openFAQ')) {
            $(answerDiv).removeClass('openFAQ').addClass('closedFAQ').slideUp(timing);
            $(questionDiv).not(this).removeClass('active');
            $(this).addClass('active');
            $(this).children(answerDiv).removeClass('closedFAQ').addClass('openFAQ').slideDown(timing);
        } else {
            $(this).children(answerDiv).removeClass('closedFAQ').addClass('openFAQ').slideDown(timing);
            $(this).addClass('active');
        }
    });
    //End of FAQ Accordion changes
});